import React from "react";
import Icon from "../Icon";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import InputField from "../InputField";
import Button from "../Button";
import DropdownC from "../Dropdown";

export default function VerifyPhone({
  open,
  onClose,
  phone,
  options,
  countryCode,
  onChangeDropdown,
  onChangePhone,
  buttonClickedUpdatePhone,
}) {
  return (
    <div>
      <Popup
        modal
        closeOnDocumentClick={false}
        open={open}
        onClose={onClose}
        contentStyle={{
          backgroundColor: "#fff",
          borderRadius: "20px",
          position: "relative",
          width: "350px",
          padding: "40px 30px 25px 20px",

          alignItems: "center",
        }}
      >
        <div
          className=" flex mt-5 flex-col justify-center gap-y-3 overflow-y-scroll overflow-x-hidden h-fit "
          style={{ maxHeight: "70vh" }}
        >
          <p className="text-xl text-gray6 font-hkBold text-center pb-2">
            ENTER MOBILE NUMBER
          </p>
          <div
            className={` flex 
           flex-row space-x-1 "
        mt-2`}
          >
            <DropdownC
              placeholder="CC"
              value={countryCode}
              width={"w-56"}
              options={options}
              onChange={onChangeDropdown}
            />
            <InputField
              width={"w-3/4"}
              type={"number"}
              icon={true}
              iconName={"icon-phone"}
              placeholder={"123 123 1235"}
              height={"h-14"}
              name={"phone"}
              value={phone.value}
              message={phone.message}
              error={phone.error}
              onInputChange={onChangePhone}
            />
          </div>

          <Button
            title="CONTINUE"
            width="w-full"
            height="h-14"
            disabled={phone.value === "" ? true : false}
            additionStyle="mt-2"
            onButtonClick={buttonClickedUpdatePhone}
          />
        </div>
        <Icon name="icon-close-modal" onClick={onClose} />
      </Popup>
    </div>
  );
}
